var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [
        _vm._v("Access to financing for high-growth African companies"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Asoko Deal Platform is an exciting new extension to the Asoko platform, built around one core objective: connecting you with the right institutions to satisfy your financing requirements."
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("Learn More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Qualifying companies can access Asoko's continuously expanding ecosystem of investors, banks, lenders and advisories through a "
      ),
      _c("b", [_vm._v("free")]),
      _vm._v(" submission process."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }